import { ListingSortFieldAndOrder } from "../listing/ListingSortField"
import PriceLevel from "./PriceLevel"
import { ADD_PRICE_LEVEL, SET_PRICE_LEVELS, SORT_PRICE_LEVELS, UPDATE_PRICE_LEVELS } from "./PriceLevelActionType"
import PriceLevelService from "./PriceLevelService"

export function setPriceLevels(priceLevels: PriceLevel[]) {
    return {
        type: SET_PRICE_LEVELS,
        payload: { priceLevels: priceLevels }
    }
}

export function addPriceLevelAction(priceLevel: PriceLevel) {
    return {
        type: ADD_PRICE_LEVEL,
        payload: { priceLevel: priceLevel }
    }
}

export function sortPriceLevelsAction(params: ListingSortFieldAndOrder) {
    return {
        type: SORT_PRICE_LEVELS,
        payload: { sortParams: params }
    }
}

export function updatePriceLevelAction(priceLevel: PriceLevel) {
    return {
        type: UPDATE_PRICE_LEVELS,
        payload: { priceLevel: priceLevel }
    }
}

export function fetchPriceLevels() {
    return async dispatch => {
        const items = await PriceLevelService.getAll()
        if (items instanceof Array) {
            dispatch(setPriceLevels(items))
        }
    }
}



// WEBPACK FOOTER //
// ./src/state/price-level/PriceLevelActions.ts